// Feature flags for the Pre-Inspection slice.
//
// `NEXT_PUBLIC_PRE_INSPECTION_GETS_ENABLED` gates the list / detail screens
// on the real backend endpoints. Set it to "true" once Sprint 2 T44 (GET list)
// and T51 (GET detail) ship. Until then the screens render a placeholder
// instead of hitting URLs that will 404.

export function arePreInspectionGetsEnabled(): boolean {
  return process.env.NEXT_PUBLIC_PRE_INSPECTION_GETS_ENABLED === 'true';
}

// Gates the status-transition action row on the detail screen against the
// job-service endpoints (GET /api/v1/admin/status/{code}/transitions, PATCH
// /api/v1/jobs/{id}/status). Off by default until deployment is verified.
export function arePreInspectionTransitionsEnabled(): boolean {
  return process.env.NEXT_PUBLIC_PRE_INSPECTION_TRANSITIONS_ENABLED === 'true';
}
